export const experienceData = [
    {
        id: 1,
        company: 'Ecell IIIT Pune',
        jobtitle: 'Web Developer',
        startYear: '2023',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'GSSOC',
        jobtitle: 'Contributor',
        startYear: '2024',
        endYear: '2024'
    },
]